import { toast } from 'react-toastify';

export function toastUnmappedException(e, message) {
  if (e?.response?.status >= 400 && e?.response?.status < 500) {
    toast.error(message, { style: { width: '392px' } });
  }
}
